// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pOVuLwxA8p {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.pOVuLwxA8p h4 {
  line-height: 3em;
}
.pOVuLwxA8p .RuGAuLzoUf {
  float: left;
  width: 100%;
}
.pOVuLwxA8p .P6guycNf_I {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.pOVuLwxA8p .P6guycNf_I:hover {
  cursor: pointer;
}
.pOVuLwxA8p .P6guycNf_I:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.svUXFEVEVy .hJEpviRvFp:focus {
  outline: none;
}
.svUXFEVEVy .hJEpviRvFp.dXKQTWRsxz.lpTs6Q9p_R {
  background: #375A88;
}
.svUXFEVEVy .hJEpviRvFp.dXKQTWRsxz.lpTs6Q9p_R span {
  color: #fff;
}
.svUXFEVEVy .lpTs6Q9p_R {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.svUXFEVEVy .lpTs6Q9p_R:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.svUXFEVEVy input {
  height: 38px;
  min-width: 220px;
}
.P6guycNf_I.HJVUDmUKVs {
  background: #410102;
}
.P6guycNf_I.ok0QvvdQOe {
  background: #911318;
}
.P6guycNf_I.lyOrZy3dCL {
  background: #D8293B;
}
.P6guycNf_I.O2qXPXG1XP {
  background: #F2373C;
}
.P6guycNf_I.HkcF2y0NNg {
  background: #FC4448;
}
.P6guycNf_I.p473mYRu5G {
  background: #ED535E;
}
.P6guycNf_I.Rm2HCm6pYr {
  background: #E34926;
}
.P6guycNf_I.CrubdAVwMR {
  background: #FC562B;
}
.P6guycNf_I.PmAsEcqM_v {
  background: #FC6722;
}
.P6guycNf_I.FRXx5Nsk1H {
  background: #FD7F24;
}
.P6guycNf_I.Ju0_Km0q9P {
  background: #FD8D26;
}
.P6guycNf_I.amRqHDsL5Q {
  background: #EC9C3E;
}
.P6guycNf_I.XtgORHojXS {
  background: #0e673a;
}
.P6guycNf_I.SsYR9YJY_i {
  background: #208740;
}
.P6guycNf_I.SsYPcXg5sk {
  background: #239718;
}
.P6guycNf_I.UU6Jll1a7t {
  background: #55A84D;
}
.P6guycNf_I.qjbdqSfwFA {
  background: #4BBE5A;
}
.P6guycNf_I.QkkPHATsl4 {
  background: #0CCA6A;
}
.P6guycNf_I.qxXm0jxXRq {
  background: #0A3C64;
}
.P6guycNf_I.mIdrorOPNS {
  background: #0d487a;
}
.P6guycNf_I.s7IvrISdu3 {
  background: #10538d;
}
.P6guycNf_I.OlZxg1XKFk {
  background: #115A99;
}
.P6guycNf_I.DQDSFPQxkb {
  background: #3387E2;
}
.P6guycNf_I.P9MdTUReuC {
  background: #1BA9CF;
}
.P6guycNf_I.zhUvbZtdSw {
  background: #d27c02;
}
.P6guycNf_I.KQ0ZFbJeZ7 {
  background: #fb9402;
}
.P6guycNf_I.f5P7vZEp3m {
  background: #FD9B30;
}
.P6guycNf_I.x56Z11m7qN {
  background: #FDBE2D;
}
.P6guycNf_I.aIlREIIFZg {
  background: #FED831;
}
.P6guycNf_I.hFIb7rnV_j {
  background: #FFFD38;
}
.P6guycNf_I.h9w02bW0Z_ {
  background: #2D215C;
}
.P6guycNf_I.q2I3otggyf {
  background: #483C83;
}
.P6guycNf_I._PFqM8dqPj {
  background: #58518d;
}
.P6guycNf_I.FUTxnj6zD2 {
  background: #7068A9;
}
.P6guycNf_I.NFHEdtXEiv {
  background: #7f78b2;
}
.P6guycNf_I.a1Ftw3H3wM {
  background: #8f88bc;
}
.P6guycNf_I.Qlnc8NirGj {
  background: #000;
}
.P6guycNf_I.m8yVFWFt28 {
  background: #282626;
}
.P6guycNf_I.gAbdXeGOYH {
  background: #242222;
}
.P6guycNf_I.MsFWCsoE6X {
  background: #353838;
}
.P6guycNf_I.DZulRF0pMh {
  background: #666;
}
.P6guycNf_I.Wr3TPTQx_L {
  background: #999;
}
.Z6n1Yswqs6 {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.Z6n1Yswqs6 .MRR0aOyHGB {
  display: none;
}
.RuYJ3lrLU5 .gfR2F_MJhP {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.RuYJ3lrLU5 .gfR2F_MJhP .tUZZYgsTyj {
  cursor: pointer;
  min-width: 45%;
  flex: 1;
}
.RuYJ3lrLU5 .gfR2F_MJhP .tUZZYgsTyj .mES_DLFtb5 {
  height: 220px;
}
.RuYJ3lrLU5 .gfR2F_MJhP .I77rVgzXyU {
  background: white;
  aspect-ratio: 1.2;
  object-fit: contain;
}
.RuYJ3lrLU5 .gfR2F_MJhP .IMkkftWAxi {
  min-width: 100%;
}
.RuYJ3lrLU5 .JwI0nS6wkB {
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 11px;
}
.mw_EnRRwy_ {
  display: inline !important;
  width: 100%;
}
.mw_EnRRwy_ .TBvdGeStSj {
  background-color: #fff;
  min-height: 225px;
  border-radius: 4px;
  overflow: hidden;
}
.mw_EnRRwy_ .TBvdGeStSj .BRkX8AO7aR {
  object-fit: contain;
  max-height: 225px;
  width: 100%;
}
.mw_EnRRwy_ .TBvdGeStSj .Y8UQCplMIw {
  border-radius: 4px 4px 0 0;
  background: #d9d9d9;
}
.mw_EnRRwy_ .TBvdGeStSj .MXctNulvFj {
  color: black;
  font-weight: 700;
  padding: 4px 8px;
}
.mw_EnRRwy_ .TBvdGeStSj .MXctNulvFj .td8CC4o6FE {
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.mw_EnRRwy_ .TBvdGeStSj .MXctNulvFj .SY2dGzMuK1 {
  margin-left: 2px;
  text-decoration: underline;
}
.mw_EnRRwy_ .TBvdGeStSj .MXctNulvFj .GqkSwP8GAm {
  width: 100%;
  max-width: 100% !important;
}
.mw_EnRRwy_ .TBvdGeStSj .V6V22ZYCAo {
  text-align: start;
  background-color: #fff;
  padding: 8px;
}
.mw_EnRRwy_ .TBvdGeStSj .vHV3fcEwZ3 {
  background: #d9d9d9;
  text-align: center;
}
.mw_EnRRwy_ .TBvdGeStSj .vHV3fcEwZ3 .ed4VAGCG_F {
  color: #383D41;
  font-size: 160px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `pOVuLwxA8p`,
	"color-row": `RuGAuLzoUf`,
	"color-tile": `P6guycNf_I`,
	"picker-component": `svUXFEVEVy`,
	"picker-element": `hJEpviRvFp`,
	"active": `dXKQTWRsxz`,
	"btn": `lpTs6Q9p_R`,
	"red-1": `HJVUDmUKVs`,
	"red-2": `ok0QvvdQOe`,
	"red-3": `lyOrZy3dCL`,
	"red-4": `O2qXPXG1XP`,
	"red-5": `HkcF2y0NNg`,
	"red-6": `p473mYRu5G`,
	"orange-1": `Rm2HCm6pYr`,
	"orange-2": `CrubdAVwMR`,
	"orange-3": `PmAsEcqM_v`,
	"orange-4": `FRXx5Nsk1H`,
	"orange-5": `Ju0_Km0q9P`,
	"orange-6": `amRqHDsL5Q`,
	"green-1": `XtgORHojXS`,
	"green-2": `SsYR9YJY_i`,
	"green-3": `SsYPcXg5sk`,
	"green-4": `UU6Jll1a7t`,
	"green-5": `qjbdqSfwFA`,
	"green-6": `QkkPHATsl4`,
	"blue-1": `qxXm0jxXRq`,
	"blue-2": `mIdrorOPNS`,
	"blue-3": `s7IvrISdu3`,
	"blue-4": `OlZxg1XKFk`,
	"blue-5": `DQDSFPQxkb`,
	"blue-6": `P9MdTUReuC`,
	"yellow-1": `zhUvbZtdSw`,
	"yellow-2": `KQ0ZFbJeZ7`,
	"yellow-3": `f5P7vZEp3m`,
	"yellow-4": `x56Z11m7qN`,
	"yellow-5": `aIlREIIFZg`,
	"yellow-6": `hFIb7rnV_j`,
	"purple-1": `h9w02bW0Z_`,
	"purple-2": `q2I3otggyf`,
	"purple-3": `_PFqM8dqPj`,
	"purple-4": `FUTxnj6zD2`,
	"purple-5": `NFHEdtXEiv`,
	"purple-6": `a1Ftw3H3wM`,
	"black-1": `Qlnc8NirGj`,
	"black-2": `m8yVFWFt28`,
	"black-3": `gAbdXeGOYH`,
	"black-4": `MsFWCsoE6X`,
	"black-5": `DZulRF0pMh`,
	"black-6": `Wr3TPTQx_L`,
	"picker-theme": `Z6n1Yswqs6`,
	"arrow-regular": `MRR0aOyHGB`,
	"assets-preview": `RuYJ3lrLU5`,
	"asset-items": `gfR2F_MJhP`,
	"asset-item__root": `tUZZYgsTyj`,
	"asset-item__media": `mES_DLFtb5`,
	"asset-item__root--progress": `I77rVgzXyU`,
	"asset-item__root--Col": `IMkkftWAxi`,
	"asset-count": `JwI0nS6wkB`,
	"preview__url": `mw_EnRRwy_`,
	"url-thumbnail": `TBvdGeStSj`,
	"url-thumbnail__img": `BRkX8AO7aR`,
	"url-thumbnail__img--readyUrl": `Y8UQCplMIw`,
	"url-thumbnail__info": `MXctNulvFj`,
	"thumbnail-info__url": `td8CC4o6FE`,
	"thumbnail-info__tooltip": `SY2dGzMuK1`,
	"thumbnail-tooltip__ctn": `GqkSwP8GAm`,
	"url-thumbnail__info--notReady": `V6V22ZYCAo`,
	"url-thumbnail__notReady": `vHV3fcEwZ3`,
	"notReady-icon": `ed4VAGCG_F`
};
export default ___CSS_LOADER_EXPORT___;
